__webpack_require__.p = "/b/a/ecom-order-portal/98ab788c5b3d3326ecf5e2655c084007666c69cd/_next/";